import axios from 'axios';
import { getApiHeader } from './../services/getApiHeaders';

export function savePrinter(data) {
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/printer/saveprintersetting',
        headers: getApiHeader(),
        withCredentials: true,
        data,
    }
    return axios(options)
}

export function getPrinter() {
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/printer/getprintersetting',
        headers: getApiHeader(),
        withCredentials: true,
    }
    return axios(options)
}



// WEBPACK FOOTER //
// ./src/utils/settingPrinter.js